import React from 'react'
import styles from './approved.styles'
import injectSheet from 'react-jss'
import happyBear from './happy-bear.gif'
import Button from 'pobble-components/dist/button'
import Container from '../../components/container/container'
import Title from '../../components/title/title'
import Description from '../../components/description/description'

const Approved = ({ classes }) => (
  <Container>
    <img className={classes.img} src={happyBear} alt="Parent approved pupil" />
    <Title>Success!</Title>
    <Description>
      <p>
        We have registered your permission. You can always adjust this setting
        via your Pobble profile
      </p>
    </Description>
    <Button tall href="/">
      Go to Pobble
    </Button>
  </Container>
)

export default injectSheet(styles)(Approved)
